import { Navigate, Route, Routes, useParams } from "react-router";
import AppLayout from "@/components/layouts/app.layout";
import RequireCustomerId from "@/components/layouts/require-customer-id.layout";
import { PathPatterns, RoutePaths } from "@/config/route-paths";
import CustomerSelectionPage from "@/features/customers/pages/customer-list/customer-list.page";
import { organizationsRoutes } from "@/features/organizations/routes/organizations-routes";
import { credentialsRoutes } from "@/features/credentials/routes/credential.routes";
import { seasonsRoutes } from "@/features/seasons/routes/season.routes";

function CustomerHomeRedirect() {
  const { customerId } = useParams();

  if (!customerId) {
    return <Navigate to={PathPatterns.customers.list} replace />;
  }

  return <Navigate to={RoutePaths.organizations.list({ customerId: Number(customerId) })} replace />;
}

export const AppRoutes = () => (
  <Routes>
    <Route element={<AppLayout />}>
      <Route path={PathPatterns.customers.list} element={<CustomerSelectionPage />} />
      <Route element={<RequireCustomerId />}>
        {organizationsRoutes}
        {credentialsRoutes}
        {seasonsRoutes}
        <Route path={PathPatterns.customers.home} element={<CustomerHomeRedirect />} />
      </Route>
      <Route path="*" element={<Navigate to={PathPatterns.customers.list} replace />} />
    </Route>
  </Routes>
);
